import React from 'react'
import ReactDOM, { hydrate, render } from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
// import ThemeContextProvider from "./contexts/Theme"
import { Provider } from 'react-redux'
import { rootState } from './store/reducers'
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import { auth, firestore } from './firebase'
import { LOGIN, AUTH_ERROR, SET_LOADING, RESET_LOADING } from './store/types'
import { User } from './models/user'

const renderLoader = () => {
  ReactDOM.render(
    <div className="loader">
      <span uk-spinner="ratio: 4.5" style={{ margin: 'auto' }}></span>
    </div>,
    document.getElementById('root')
  )
}

export const store = createStore(
  rootState,
  composeWithDevTools(applyMiddleware(thunk))
)

store.dispatch({ type: SET_LOADING })
auth.onAuthStateChanged(async (user) => {
  renderLoader()
  try {
    if (user) {
      let res = await (
        await firestore.collection('users').doc(user.uid).get()
      ).data()
      let usr: User = {
        pimage: '',
        accountType: res?.accountType,
        bio: res?.bio,
        email: res?.email,
        fans: res?.fans,
        firstName: res?.firstName,
        lastName: res?.lastName,
        location: res?.location,
        id: user.uid,
        username: res?.username,
        website: res?.website,
      }

      store.dispatch({
        type: LOGIN,
        payload: usr,
      })
    } else {
      store.dispatch({ type: AUTH_ERROR })
    }
    store.dispatch({
      type: RESET_LOADING,
    })
  } catch (error) {
    store.dispatch({ type: AUTH_ERROR })
    store.dispatch({
      type: RESET_LOADING,
    })
  } finally {
    const rootElement = document.getElementById('root')!
    if (rootElement.hasChildNodes()) {
      hydrate(
        <Provider store={store}>
          <App />
        </Provider>,
        rootElement
      )
    } else {
      render(
        <Provider store={store}>
          <App />
        </Provider>,
        rootElement
      )
    }
    // ReactDOM.render(
    //   <Provider store={store}>
    //     {/* <ThemeContextProvider> */}
    //     <App />
    //     {/* </ThemeContextProvider> */}
    //   </Provider>,
    //   document.getElementById("root")
    // );
  }
})

renderLoader()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({})
